import { Helmet } from 'react-helmet-async';
import {
  SITE_NAME,
  PARENT_COMPANY,
  DEFAULT_OG_IMAGE,
  TWITTER_HANDLE,
  getCanonicalUrl,
} from '../../content/seo';
import { officeLocations } from '../../content/contactPageContent';

const OFFICE = officeLocations[0];

function JsonLd({ data }) {
  if (!data?.length) return null;
  return (
    <Helmet>
      {data.map((schema, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
}

export default function Seo({
  title,
  description,
  keywords = [],
  path = '/',
  image = DEFAULT_OG_IMAGE,
  type = 'website',
  noindex = false,
  schemas = [],
}) {
  const canonical = getCanonicalUrl(path);
  const keywordString = Array.isArray(keywords) ? keywords.join(', ') : keywords;
  const fullTitle = title.includes(SITE_NAME) ? title : `${title} | ${SITE_NAME}`;

  return (
    <>
      <Helmet>
        <html lang="en-IN" />
        <title>{fullTitle}</title>
        <meta name="description" content={description} />
        {keywordString ? <meta name="keywords" content={keywordString} /> : null}
        <link rel="canonical" href={canonical} />

        <meta name="robots" content={noindex ? 'noindex, nofollow' : 'index, follow, max-image-preview:large'} />
        <meta name="author" content={`${SITE_NAME}, ${PARENT_COMPANY}`} />
        <meta name="geo.region" content="IN-GJ" />
        <meta name="geo.placename" content="Surat, Gujarat, India" />
        <meta name="geo.position" content={`${OFFICE.lat};${OFFICE.lng}`} />
        <meta name="ICBM" content={`${OFFICE.lat}, ${OFFICE.lng}`} />
        <meta name="language" content="English" />
        <meta name="coverage" content="India" />
        <meta name="distribution" content="global" />
        <meta name="rating" content="general" />

        <meta property="og:site_name" content={SITE_NAME} />
        <meta property="og:title" content={fullTitle} />
        <meta property="og:description" content={description} />
        <meta property="og:type" content={type} />
        <meta property="og:url" content={canonical} />
        <meta property="og:image" content={image} />
        <meta property="og:image:alt" content={`${SITE_NAME} — pharma logistics and fleet SaaS`} />
        <meta property="og:locale" content="en_IN" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content={TWITTER_HANDLE} />
        <meta name="twitter:title" content={fullTitle} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={image} />
      </Helmet>
      <JsonLd data={schemas} />
    </>
  );
}

export { JsonLd };
